export const enUS = {
  productEdges: 'Product Edges',
}
